import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_COMPLETE = gql `
  mutation UpdateWarehouseReleaseComplete($warehouseReleaseNodeId: ID!) {
    completeWarehouseRelease(warehouseReleaseNodeId: $warehouseReleaseNodeId) {
      warehouseRelease {
        id
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_COMPLETE;
